// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'styled-components';
import { useIconSize } from '../useIconSize';
import { jsx as _jsx } from "react/jsx-runtime";
export const ViewIcon = ({
  size = 'inherit',
  color = 'inherit',
  'aria-label': ariaLabel,
  id
}) => {
  const theme = useTheme();
  const sizeValue = useIconSize(size);
  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // currentColor = color of the parent element

  return /*#__PURE__*/_jsx("svg", {
    width: sizeValue,
    height: sizeValue,
    fill: colorValue,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "View",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16 12.35c2.02 0 3.65 1.63 3.65 3.65s-1.63 3.65-3.65 3.65-3.65-1.63-3.65-3.65 1.63-3.65 3.65-3.65m13.8 2.73c-1.15-2.4-5.76-7.85-13.73-7.85-6.18 0-11.18 3.18-13.87 7.89 0 0-.2.35-.2.87 0 .42.16.8.16.8 3.98 6.48 9.99 7.97 14.05 7.97 5.72 0 10.89-3.18 13.57-7.9 0 0 .22-.44.22-.85s-.14-.8-.2-.93m-3.6.94c-2.23 3.19-5.99 5.23-10.01 5.23-4.46 0-6.42-1.51-6.42-1.51-1.86-1.1-3.96-3.67-3.99-3.69s0-.06 0-.06c2.23-3.2 5.87-5.25 10.01-5.25h.19c5.43 0 7.24 2.08 10.06 5.05.09.1.16.15.16.17.02.03 0 .06 0 .06"
    })
  });
};